export default __webpack_public_path__ + "static/media/spr-background-volcanism-large.930ecd6b.jpg";